module.exports = __webpack_public_path__ + "img/offline2.de6b66d3.svg";